import { z } from 'zod';

// ─── Request/Response Schemas ──────────────────────────────────────────────────

export const ComponentInstantiationRequestSchema = z.object({
  templateRef: z.string(),
  values: z.record(z.any()),
  environmentParameters: z.record(z.record(z.any())).optional(),
  displayName: z.string(),
  description: z.string().optional(),
  entityRef: z.string().optional(),
});

export type ComponentInstantiationRequest = z.infer<
  typeof ComponentInstantiationRequestSchema
>;

export const CreateBulkImportRequestSchema = z.object({
  systemEntityRef: z.string(),
  components: z.array(ComponentInstantiationRequestSchema).min(1),
});

export type CreateBulkImportRequest = z.infer<
  typeof CreateBulkImportRequestSchema
>;

// ─── Response Types ────────────────────────────────────────────────────────────

export type BulkImportTaskResponse = {
  templateRef: string;
  displayName: string;
  description?: string;
  /** Set once the scaffolder task has been created. Absent for tasks not yet started. */
  instantiationTaskId?: string;
  /** The type of operation: 'create' for new components, 'sync' for existing ones. Defaults to 'create'. */
  operationType?: 'create' | 'sync';
  /** Entity reference of the existing component. Present only for sync operations. */
  entityRef?: string;
  /** Status of the sync operation. Present only for sync tasks. */
  syncStatus?: 'pending' | 'completed' | 'failed';
  /** Error message if the sync operation failed. */
  syncError?: string;
};

export type BulkImportResponse = {
  id: string;
  systemEntityRef: string;
  createdBy: string;
  tasks: BulkImportTaskResponse[];
  createdAt: string;
};

export type CreateBulkImportResponse = {
  id: string;
};
